
import { serviceAreas } from '../../../mocks/serviceAreas';

const RemovalsAreas = () => {
  return (
    <div className="mb-16">
      <h2 className="font-serif text-4xl font-bold text-charcoal mb-4">
        Service Coverage Across KwaZulu-Natal
      </h2>
      <p className="text-gray-600 text-lg mb-8 leading-relaxed">
        We provide bakkie removal services throughout KwaZulu-Natal, from major urban centers to rural communities. Our local knowledge ensures efficient routes and reliable service wherever you need us.
      </p>

      <div className="bg-white rounded-xl border-2 border-greenbg p-8">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-8">
          {serviceAreas.map((area) => (
            <div
              key={area.id}
              className="flex items-center space-x-2 p-3 bg-greenbg rounded-lg hover:bg-primary/10 transition-colors"
            >
              <i className="ri-map-pin-fill text-primary w-5 h-5 flex items-center justify-center"></i>
              <span className="font-medium text-charcoal text-sm">{area.name}</span>
            </div>
          ))}
        </div>

        <div className="bg-primary/5 rounded-lg p-6">
          <h4 className="font-bold text-lg text-charcoal mb-3">
            Don't See Your Area Listed?
          </h4>
          <p className="text-gray-700 mb-4 leading-relaxed">
            We service many more locations across KwaZulu-Natal, including rural areas. Contact us to confirm service availability in your specific location. We're committed to serving all communities across KZN.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://wa.me/27798768956"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center bg-primary text-white px-6 py-3 rounded-full font-semibold hover:bg-primary-dark transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line mr-2 w-5 h-5 flex items-center justify-center"></i>
              WhatsApp Us
            </a>
            <a
              href="tel:+27798768956"
              className="inline-flex items-center justify-center bg-white border-2 border-primary text-primary px-6 py-3 rounded-full font-semibold hover:bg-primary hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2 w-5 h-5 flex items-center justify-center"></i>
              Call 079 876 8956
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RemovalsAreas;
